import { apiClient } from './api';
import type { BrandSettings, UpdateBrandSettingsInput } from '@/types/brand';

export const brandService = {
  // Get the brand settings (singleton)
  getBrandSettings: async (): Promise<BrandSettings> => {
    const response = await apiClient.get<BrandSettings>('/settings/brand');
    return response.data as BrandSettings;
  },

  // Update the brand settings
  updateBrandSettings: async (input: UpdateBrandSettingsInput): Promise<BrandSettings> => {
    const response = await apiClient.put<BrandSettings>('/settings/brand', input);
    return response.data as BrandSettings;
  },
};

// Legacy exports for backward compatibility
// @deprecated Use brandService.getBrandSettings instead
export const getCurrentBrand = brandService.getBrandSettings;
